<template>
  <ion-page>
    <ion-header>
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-menu-toggle auto-hide="false">
            <img src="../assets/svg/logo-toolbar.svg">
            <!-- <ion-button>
              <ion-icon slot="icon-only" name="menu"></ion-icon>
            </ion-button> -->
          </ion-menu-toggle>
        </ion-buttons>
        <ion-buttons slot="end">
          <ion-button class="btn-back" @click="$router.go(-1)">Back</ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content padding>
      <bg :opaque="1"></bg>
      <ion-grid>
        <div class="mt-20">{{ $route.params.name }}</div>
        <form @submit="save" class="row-boxed mt-20">
          <div class="fix-padded">
            <nested-draggable :k="0" @add="(i) => add(i)" :indices="indices" v-if="indices" :type="(indices[0].cod || indices[0].ref) ? 'index' : 'worklist'"></nested-draggable>
          </div>
          <ion-row>
            <ion-col size="12" class="text-right">
              <ion-button @click="saveTemplateApi" type="button">SAVE TEMPLATE</ion-button>
            </ion-col>
          </ion-row>
          <!-- Permette l'invio del form con tasto enter -->
          <input type="submit" class="hidden">
        </form>

      </ion-grid>
      <loader :visible="loader"></loader>
    </ion-content>
  </ion-page>
</template>

<script>
import axios from "axios"
import Vue from "vue"
import nestedDraggable from './partials/Nested'
export default {
  name: "TemplatesEdit",
  components: {
    nestedDraggable
  },
  data: function() {
    return {
      indices: [],
      loader: true,
      back: this.$route.params.back ? this.$route.params.back : false,
    }
  },
  computed: {
    indicesSave: function(){
      let indices = JSON.parse(JSON.stringify(this.indices))
      let indicesSave = []
      indicesSave = indicesSave.concat(this.splitIndices(indices, ''))
      return indicesSave
    }
  },
  methods: {
    splitIndices: function(arrayLoop, parent){
      let indicesSave = []
      if(arrayLoop.length) {
        let x = 0
        while (x < arrayLoop.length) {
          arrayLoop[x].parent = parent
          indicesSave.push(arrayLoop[x])
          if(arrayLoop[x].indices.length) {
            parent = arrayLoop[x].ref
            indicesSave = indicesSave.concat(this.splitIndices(arrayLoop[x].indices, parent))
            parent = ''
          }
          x++
        }
      }
      return indicesSave
    },
    save(ev) {
      ev.preventDefault()
    },
    saveTemplateApi() {
      this.loader = true;
      axios.post(this.apiUrl + '/api/v1/save-indices-template', { api_token: this.$store.state.api_token, indices: this.indicesSave, name: this.$route.params.name })
      .then(async(response) => {
        let res = response.data
        if(res.status == 1) {
          const toast = await this.$ionic.toastController.create({
            message: 'Template saved succesfully',
            color: 'success',
            position: 'bottom',
            duration: 2000
          })
          await toast.present();
        }
        this.loader = false;

        const toast = await this.$ionic.toastController.create({
          message: 'Template saved succesfully',
          color: 'success',
          position: 'bottom',
          duration: 2000
        })
        await toast.present();
      })
    },
    // remove(index) {
    //   this.indices.splice(index, 1);
    // },
    add() {
      let obj = {
        id: '',
        report_id: '',
        ref: '',
        cod: '',
        title: '',
        type: '',
        parent: '',
        order: '',
        user_id_added: '',
        user_id_edited: '',
        indices: [],
      }

      Vue.set(this.indices, this.indices.length, obj);
    },
  },
  mounted: function() {
    axios.post(this.apiUrl + '/api/v1/get-indices', { api_token: this.$store.state.api_token, name: this.$route.params.name })
    .then((response) => {
      let res = response.data
      if(res.data.length) {
        let i = 0
        while (i < res.data.length) {
          Vue.set(this.indices, this.indices.length, res.data[i]);
          i++
        }
      } else {
        // Non sono presenti indici, creo una riga vuota
        this.add()
      }
      this.loader = false;
    })
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>